import Crud from '../views/Tripulacao/Crud'
import Entity from '../views/Tripulacao/Add'

let routes = {
    path: '/tripulacaos',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/tripulacaos/add',
            name: 'NewTripulacao',
            component: Entity
        },
        {
            path: '/tripulacaos/edit/:id?',
            name: 'EditTripulacao',
            component: Entity
        },
        {
            path: '/tripulacaos',
            name: 'list-tripulacaos',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Tripulações',
                breadcrumb: [
                    {
                        text: 'Tripulações',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
